/**
 * Цена тарифа в человеческом виде: 39900 копеек и 'RUB' → «399 ₽».
 *
 * Бэк отдаёт цену в минорных единицах (GET /billing/plans, поле price), а показывать
 * надо мажорные. Деление живёт в toPlan (api/endpoints/billing.ts) — здесь только вид.
 */

/**
 * Дробную часть показываем только когда она есть: «399 ₽», но «399,50 ₽».
 * Круглая цена с копейками («399,00 ₽») выглядит как ошибка вёрстки.
 */
function fractionDigits(minor: number): number {
	return minor % 100 === 0 ? 0 : 2
}

export function formatPrice(minor: number, currency: string): string {
	const major = minor / 100
	const digits = fractionDigits(minor)
	try {
		return new Intl.NumberFormat('ru-RU', {
			style: 'currency',
			currency,
			minimumFractionDigits: digits,
			maximumFractionDigits: digits
		}).format(major)
	} catch {
		// Intl бросает на неизвестном коде валюты. Показать число с кодом честнее,
		// чем уронить экран или спрятать цену.
		return `${major.toLocaleString('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits })} ${currency}`
	}
}
